import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetEntityTceCountUseCaseInterface } from 'domain/usecases';

export class RemoteGetEntityTceCount
  implements GetEntityTceCountUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetEntityTceCountUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetEntityTceCountUseCaseInterface.Params,
  ): Promise<GetEntityTceCountUseCaseInterface.Result> {
    const requestUrl = `${this.url}/${params.entityId}/tces-counts`;
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
